module.exports = __webpack_public_path__ + "static/bg-live-9e0a168adb77f391578f8960deffbeb3.jpg";